import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import ScrollTopBehavior from '../components/ScrollTopBehavior'
import RouteSeoManager from '../components/seo/RouteSeoManager'

//Home Pages
import ItSolution from '../views/home-pages/ItSolution'
import SoftwareDevelopment from '../views/home-pages/SoftwareDevelopment'
import RevenueManagementSolution from '../views/home-pages/RevenueManagementSolution'
import CyberSecurity from '../views/home-pages/CyberSecurity'

//inner-pages
//about-page
import About from '../views/inner-pages/about/About'
import CoreValues from '../views/inner-pages/about/CoreValues'
import History from '../views/inner-pages/about/History'
import HowWeWork from '../views/inner-pages/about/HowWeWork'
import NoticeList from '../views/inner-pages/notices/NoticeList'
import NoticeDetail from '../views/inner-pages/notices/NoticeDetail'

//services-pages
import Services from '../views/inner-pages/services/Services'
import ServicesDetails from '../views/inner-pages/services/ServicesDetails'
import CustomBackoffice from '../views/inner-pages/services/CustomBackoffice'
import WebsiteCreation from '../views/inner-pages/services/WebsiteCreation'
import EcommercePlatform from '../views/inner-pages/services/EcommercePlatform'
import CodamDesign from '../views/inner-pages/design/CodamDesign'
import CodamDesignPortfolio from '../views/inner-pages/design/CodamDesignPortfolio'
import CharacterDesignPortfolio from '../views/inner-pages/design/CharacterDesignPortfolio'
import CharacterDesignDetail from '../views/inner-pages/design/CharacterDesignDetail'
import CodamCharacterDetail from '../views/inner-pages/design/CodamCharacterDetail'
import ProductDesignPortfolio from '../views/inner-pages/design/ProductDesignPortfolio'
import ProductDesignDetail from '../views/inner-pages/design/ProductDesignDetail'
import IndustrialDesignPortfolio from '../views/inner-pages/design/IndustrialDesignPortfolio'
import IndustrialDesignDetail from '../views/inner-pages/design/IndustrialDesignDetail'
import { CODAM_CHARACTER_DETAIL_SLUG } from '../views/inner-pages/design/characterDesignPortfolioData'

//team-pages
import Team from '../views/inner-pages/team/Team'
import TeamDetails from '../views/inner-pages/team/TeamDetails'
import CrewRecruit from '../views/inner-pages/team/CrewRecruit'

//pages
import Price from '../views/inner-pages/pages/Price'
import Faq from '../views/inner-pages/pages/Faq'
import Error from '../views/inner-pages/pages/Error'
import Login from '../views/inner-pages/pages/Login'
import Signup from '../views/inner-pages/pages/Signup'
import ComingSoon from '../views/inner-pages/pages/ComingSoon'

//project-pages
import ProjectGrid from '../views/inner-pages/project/ProjectGrid'
import ProjectMasonry from '../views/inner-pages/project/ProjectMasonry'
import ProjectDetails from '../views/inner-pages/project/ProjectDetails'

//blog-pages
import BlogGrid from '../views/inner-pages/blog/BlogGrid'
import BlogMasonry from '../views/inner-pages/blog/BlogMasonry'
import BlogClassic from '../views/inner-pages/blog/BlogClassic'
import BlogDetailsV1 from '../views/inner-pages/blog/BlogDetailsV1'
import BlogDetailsV2 from '../views/inner-pages/blog/BlogDetailsV2'
import PrepaidCard from '../views/inner-pages/platform/PrepaidCard'
import CodamChain from '../views/inner-pages/platform/CodamChain'
import CodamPay from '../views/inner-pages/platform/CodamPay'
import CodamTalk from '../views/inner-pages/platform/CodamTalk'
import CodamMap from '../views/inner-pages/platform/CodamMap'
import CodamAiCore from '../views/inner-pages/platform/CodamAiCore'
import TechPlatform from '../views/inner-pages/platform/TechPlatform'
import DeveloperCenter from '../views/inner-pages/platform/DeveloperCenter'
import CodamDevSummit from '../views/inner-pages/platform/CodamDevSummit'
import EsgOverview from '../views/inner-pages/platform/EsgOverview'
import EsgReport from '../views/inner-pages/platform/EsgReport'
import SmeDigitalization from '../views/inner-pages/platform/SmeDigitalization'
import ActiveGreen from '../views/inner-pages/platform/ActiveGreen'
import DigitalResponsibility from '../views/inner-pages/platform/DigitalResponsibility'
import Recruit from '../views/inner-pages/platform/Recruit'
import JobPostings from '../views/inner-pages/platform/JobPostings'

//conatct-page
import Contact from '../views/inner-pages/pages/Contact'

//error-404
import NotFound from '../views/NotFound'

const AppRouter = () => {
    return (
        <>
            <ScrollTopBehavior />
            <RouteSeoManager />
            <Routes>
                <Route path="/" element={<ItSolution />} />
                <Route path="/software-development" element={<SoftwareDevelopment />} />
                <Route path="/revenue-management" element={<RevenueManagementSolution />} />
                <Route path="/cyber-security" element={<CyberSecurity />} />

                <Route path="/about" element={<About />} />
                <Route path="/core-values" element={<CoreValues />} />
                <Route path="/history" element={<History />} />
                <Route path="/how-we-work" element={<HowWeWork />} />
                <Route path="/notices/:noticeId" element={<NoticeDetail />} />
                <Route path="/notices" element={<NoticeList />} />

                <Route path="/services" element={<Services />} />
                <Route path="/services-details" element={<ServicesDetails />} />
                <Route path="/custom-backoffice" element={<CustomBackoffice />} />
                <Route path="/website-creation" element={<WebsiteCreation />} />
                <Route path="/ecommerce-platform" element={<EcommercePlatform />} />
                <Route
                    path={`/codam-design/character-design/${CODAM_CHARACTER_DETAIL_SLUG}`}
                    element={<CodamCharacterDetail />}
                />
                <Route
                    path="/codam-design/character-design/:slug"
                    element={<CharacterDesignDetail />}
                />
                <Route
                    path="/codam-design/character-design"
                    element={<CharacterDesignPortfolio />}
                />
                <Route path="/codam-design/portfolio" element={<CodamDesignPortfolio />} />
                <Route
                    path="/codam-design/product-design/:slug"
                    element={<ProductDesignDetail />}
                />
                <Route
                    path="/codam-design/product-design"
                    element={<ProductDesignPortfolio />}
                />
                <Route
                    path="/codam-design/industrial-design/:slug"
                    element={<IndustrialDesignDetail />}
                />
                <Route
                    path="/codam-design/industrial-design"
                    element={<IndustrialDesignPortfolio />}
                />
                <Route path="/codam-design" element={<CodamDesign />} />

                <Route path="/team" element={<Team />} />
                <Route path="/team-details" element={<TeamDetails />} />
                <Route path="/crew-recruit" element={<CrewRecruit />} />

                <Route path="/price" element={<Price />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/error" element={<Error />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/coming-soon" element={<ComingSoon />} />

                <Route path="/project-grid" element={<ProjectGrid />} />
                <Route path="/project-masonry" element={<ProjectMasonry />} />
                <Route path="/project-details" element={<Navigate to="/project-grid" replace />} />
                <Route path="/project-details/:slug" element={<ProjectDetails />} />

                <Route path="/blog-grid" element={<BlogGrid />} />
                <Route path="/blog-masonry" element={<BlogMasonry />} />
                <Route path="/blog-classic" element={<BlogClassic />} />
                <Route path="/blog-details-v1" element={<BlogDetailsV1 />} />
                <Route path="/blog-details-v2" element={<BlogDetailsV2 />} />
                <Route path="/prepaid-card" element={<PrepaidCard />} />
                <Route path="/codam-chain" element={<CodamChain />} />
                <Route path="/codam-pay" element={<CodamPay />} />
                <Route path="/codam-talk" element={<CodamTalk />} />
                <Route path="/codam-map" element={<CodamMap />} />
                <Route path="/codam-ai-core" element={<CodamAiCore />} />
                <Route path="/tech-platform" element={<TechPlatform />} />
                <Route path="/developer-center" element={<DeveloperCenter />} />
                <Route path="/codam-dev-summit" element={<CodamDevSummit />} />
                <Route path="/esg" element={<EsgOverview />} />
                <Route path="/esg-report" element={<EsgReport />} />
                <Route path="/sme-digitalization" element={<SmeDigitalization />} />
                <Route path="/active-green" element={<ActiveGreen />} />
                <Route path="/digital-responsibility" element={<DigitalResponsibility />} />
                <Route path="/recruit" element={<Recruit />} />
                <Route path="/job-postings" element={<JobPostings />} />

                <Route path="/contact" element={<Contact />} />

                <Route path="*" element={<NotFound />} />
            </Routes>
        </>
    )
}

export default AppRouter